var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-polygon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44115 0.928435C6.40577 0.357188 7.59423 0.357188 8.55884 0.928435L12.1912 3.07949C13.1558 3.65074 13.75 4.70645 13.75 5.84894V10.1511C13.75 11.2936 13.1558 12.3493 12.1912 12.9205L8.55884 15.0716C7.59423 15.6428 6.40577 15.6428 5.44115 15.0716L1.80885 12.9205C0.844229 12.3493 0.25 11.2936 0.25 10.1511V5.84894C0.25 4.70645 0.844229 3.65074 1.80885 3.07949L5.44115 0.928435ZM6.25 11.75C6.25 11.3358 6.58579 11 7 11C7.41421 11 7.75 11.3358 7.75 11.75C7.75 12.1642 7.41421 12.5 7 12.5C6.58579 12.5 6.25 12.1642 6.25 11.75ZM6.4375 9.5C6.4375 9.81066 6.68934 10.0625 7 10.0625C7.31066 10.0625 7.5625 9.81066 7.5625 9.5L7.5625 4.25C7.5625 3.93934 7.31066 3.6875 7 3.6875C6.68934 3.6875 6.4375 3.93934 6.4375 4.25L6.4375 9.5Z",
    fill: "#8DC63F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCube);
export default __webpack_public_path__ + "static/media/warning-cube.176f7cb4650da40f6cce847bf8b4106c.svg";
export { ForwardRef as ReactComponent };